var exports = {
  "x": "xe533113f--de5582--page-layout",
};

module.exports = exports;
